import { getAndroidUser } from './auth';

/**
 * Takes the injected object from android native and places it on the window object.
 *
 * In native android, the `injectedJavaScriptObject` is used
 * to pass data from the native side to the webview.
 *
 * Many places in the app rely on this data being available on the window object,
 * so this puts it there for easy access.
 */
export const placeAndroidInfoOnWindow = () => {
  const androidInfo = getAndroidUser();
  if (!androidInfo) {
    return;
  }
  Object.keys(androidInfo)
    .filter(key => !['userFromToken'].includes(key))
    .forEach(key => {
      (window as unknown as Record<string, unknown>)[key] =
        androidInfo[key as keyof typeof androidInfo];
    });
};
